import Auth from 'j-toker';
import * as types from './actionTypes';
import { apiGet, apiDelete, apiPutMultipart, apiPostMultipart } from 'helpers/ApiHelper';
import * as formatter from 'helpers/Formatter';
import { showFailure } from 'actions/notificationActions';

const makeUrl = path => Auth.getApiUrl() + '/landlords' + path;

export function createPromotion(data) {
  return dispatch => {
    dispatch({ type: types.CREATE_PROMOTION });
    let multiPartFormData = new FormData();

    if (data.image.lastModified) {
      multiPartFormData.append('image', data.image);
    }

    data['property_ids'] = data['properties']; // TODO: when property multiselect is addeed, please move to here

    if (data['expiration_date']) {
      data['expiration_date'] = formatter.toISO8601DateString(data['expiration_date']);
    }
    const formData = JSON.stringify(data);
    multiPartFormData.append('data', formData);

    return apiPostMultipart(makeUrl('/promotions'), multiPartFormData);
  };
}

export function editPromotion(data, promotionId) {
  return dispatch => {
    dispatch({ type: types.EDIT_PROMOTION });
    let multiPartFormData = new FormData();

    if (data.image.lastModified) {
      multiPartFormData.append('image', data.image);
    }

    data['property_ids'] = data['properties']; // TODO: when property multiselect is addeed, please move to here

    if (data['expiration_date']) {
      data['expiration_date'] = formatter.toISO8601DateString(data['expiration_date']);
    }
    const formData = JSON.stringify(data);
    multiPartFormData.append('data', formData);

    return apiPutMultipart(makeUrl(`/promotions/${promotionId}`), multiPartFormData);
  };
}

export function deletePromotion(promotionId) {
  return dispatch => {
    dispatch({ type: types.DELETE_PROMOTION });

    return apiDelete(makeUrl(`/promotions/${promotionId}`));
  };
}

export function getPromotion(promotionId) {
  return dispatch =>
    dispatch({
      type: types.FETCH_PROMOTION,
      payload: apiGet(makeUrl(`/promotions/${promotionId}`)).catch(error => {
        dispatch(showFailure(error));
      }),
    });
}
